import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ESigantureEnvelope } from 'app/modules/models/esignatureEnvelope.type';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ESigantureService {

  private _docusignNotification$ = new BehaviorSubject<any>(null);

  get docusignNotification$(): Observable<any> {
    return this._docusignNotification$.asObservable();
  }

  set docusignNotification(value: any) {
    this._docusignNotification$.next(value);
  }

  constructor(private _httpClient: HttpClient) {}

  createEnvelope(envelope: ESigantureEnvelope): Observable<any> {    
    var route = environment.RESOURCE_API +environment.apiCatalog.eSignature.controllerRoute + environment.apiCatalog.eSignature.subRoutes.createEnvelope;
    return this._httpClient.post(route, envelope, this.prepareHeader()).pipe(map(res => res as any));
  }

  getEnvelopeInfo(envelopeId: string): Observable<any> {
    var route = environment.RESOURCE_API +environment.apiCatalog.eSignature.controllerRoute + environment.apiCatalog.eSignature.subRoutes.getEnvelope + envelopeId;
    return this._httpClient.get(route, this.prepareHeader()).pipe(map(res => res as any));
  }

  getEnvelopeDocuments(envelopeId: string): Observable<any> {
    var route = environment.RESOURCE_API +environment.apiCatalog.eSignature.controllerRoute + environment.apiCatalog.eSignature.subRoutes.getEnvelopeDocuments + envelopeId;
    return this._httpClient.get(route, this.prepareHeader()).pipe(map(res => res as any));
  }
  getEnvelopeDocument(envelopeId: string , documentId): Observable<any> {
    var route = environment.RESOURCE_API +environment.apiCatalog.eSignature.controllerRoute + environment.apiCatalog.eSignature.subRoutes.getEnvelopeDocuments + envelopeId + '/' + documentId;
    return this._httpClient.get(route, this.prepareHeader()).pipe(map(res => res as any));
  }

  sendReminder(envelopeId: string): Observable<any> {
    var route = environment.RESOURCE_API +environment.apiCatalog.eSignature.controllerRoute + environment.apiCatalog.eSignature.subRoutes.sendReminder + envelopeId;
    return this._httpClient.get(route, this.prepareHeader()).pipe(map(res => res as any));
  }

  voidSignature(envelopeId: string, voidedRaison: string ): Observable<any> {
    var route = environment.RESOURCE_API +environment.apiCatalog.eSignature.controllerRoute + environment.apiCatalog.eSignature.subRoutes.voidEnvelope + envelopeId + '?voidedReason=' + voidedRaison;
    return this._httpClient.put(route, voidedRaison, this.prepareHeader()).pipe(map(res => res as any));
  
  }

   private prepareHeader(): Object {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    return { headers: headers };
  }

}
